import { CrossIcon } from "assets/icons";

function Seat({ label = "", status = "available", onClick, disabled = false }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex flex-col items-center disabled:cursor-not-allowed"
    >
      <div
        className={`w-[27px] h-[23px] rounded-[5px] z-[2] -mb-3 flex items-center justify-center animation ${
          status === "booked"
            ? "bg-[#717171] text-[#999999]"
            : status === "selected"
            ? "bg-[#D62423] text-white"
            : "bg-[#E8E8E8] text-[#999999]"
        }`}
      >
        {label && status !== "booked" && (
          <span className="text-[8px] font-bold">{label || ""}</span>
        )}
        {status === "booked" && (
          <span className="h-3 w-3">
            <CrossIcon />
          </span>
        )}
      </div>
      <div
        className={`w-[38px] h-[23px] rounded-[5px] z-0 animation ${
          status === "booked"
            ? "bg-[#5A5555]"
            : status === "selected"
            ? "bg-[#B00000]"
            : "bg-[#C8C8C8]"
        }`}
      ></div>
    </button>
  );
}

export default Seat;
